// extracted by mini-css-extract-plugin
module.exports = {"error_msg":"style_error_msg__gcae9"};